export default [
  {
    path: '/enterpriseSetting',
    name: 'EnterpriseSetting',
    meta: {
      title: '企业信息'
    },
    component: () => import('@/views/basic/EnterpriseSetting')
  },
  {
    path: '/staff',
    name: 'Staff',
    meta: {
      title: '员工管理'
    },
    component: () => import('@/views/basic/Staff')
  }
]
